import JSZip from 'jszip'
import moment from 'moment';
const colorsArray = [
    {
      label: "Black",
      value: "#000000",
    },
    {
      label: "Grey",
      value: "#808080",
    },
    {
      label: "Blue",
      value: "#0850f7",
    },
    {
      label: "Orange",
      value: "#F79722",
    },
    {
      label: "Crimson",
      value: "#DC143C",
    },
    {
      label: "Pink",
      value: "#FFC0CB",
    },
    {
      label: "Yellow",
      value: "#FFFF00",
    },
    {
      label: "Violet",
      value: "#EE82EE",
    },  
    {
      label: "DarkOrchid",
      value: "#9932CC",
    },
    {
      label: "Lime",
      value: "#00FF00",
    },
    {
      label: "SeaGreen",
      value: "#2E8B57",
    },
    {
      label: "Turquoise",
      value: "#40E0D0",
    },
    {
      label: "Bisque",
      value: "#FFE4C4",
    },
    
  ];

  const colorsArrayDisPlayOrder = [
    {
        label: "Blue",
        value: "#0850f7",
    },
    {
        label: "DarkOrchid",
        value: "#9932CC",
    },
    {
        label: "Turquoise",
        value: "#40E0D0",
    },
    {
        label: "Crimson",
        value: "#DC143C",
    },
    {
      label: "Black",
      value: "#000000",
    },
    {
      label: "Grey",
      value: "#808080",
    },
    {
      label: "Orange",
      value: "#F79722",
    },
    {
      label: "Pink",
      value: "#FFC0CB",
    },
    {
      label: "Yellow",
      value: "#FFFF00",
    },
    {
      label: "Violet",
      value: "#EE82EE",
    },  
    {
      label: "Lime",
      value: "#00FF00",
    },
    {
      label: "SeaGreen",
      value: "#2E8B57",
    },
    {
      label: "Bisque",
      value: "#FFE4C4",
    },
  ];

const gridUnitSizes = [
    {
      label: "Very small",
      gridValues: "20x20",
      value: 15
    },
    {
      label: "Small",
      gridValues: "10x10",
      value: 24
    },
    { 
      label: "Medium",
      gridValues: "10x10",
      value: 38
    },
    {
      label: "Large",
      gridValues: "6x6",
      value: 72
    },
    {
      label: "Very large",
      gridValues: "2x2",
      value: 100
    },
  ];

  const AngleDisplayOptions = [
    {
      label: "Angle displayed (by an arc) is the smallest angle, and always positive, question author can designate the reference (that is the axis from which the angle is referred. The reference can be at any angle compared to the +x axis). Question author can designate the reference",
      value: 1,
    },
    {
      label: "Angle displayed (by an arc) is chosen to start from the reference and go either clockwise or counterclockwise, and always is positive. Question author can designate the reference, and CC/CCW option",
      value: 2,
    },
    {
      label: "Angle displayed (by an arc) starts from the +x axis as the reference and will be the smallest angle, but will be indicated as positive number if the angle is CCW from the reference and negative if CW from the reference",
      value: 3,
    }
  ];

  const evaluateOptions = [
    {
      label: "=",
      value: 0,
    },
    {
      label: ">",
      value: 1,
    },
    {
      label: "<",
      value: 2,
    },
    {
      label: ">=",
      value: 3,
    },
    {
      label: "<=",
      value: 4,
    }
  ];
  const QueryOptions = [
    {
      label: "AND",
      value: 0,
    },
    {
      label: "OR",
      value: 1,
    }
  ];

  const getColorsArrayDisPlayOrder = (index) =>{
	return colorsArrayDisPlayOrder[index%colorsArrayDisPlayOrder.length].value
  }

  const downloadErrorInfo = (error)=> {

    const zip = new JSZip();

    const errorData = {
      error: {
        message: error.message,
        stack: error.stack,
      },
      gnbArr: JSON.parse(window.localStorage.getItem('gnbArr')),
    };

    const errorDataJSON = JSON.stringify(errorData, null, 2);


    const fileName = `error_info_${moment().format('MM-DD-YY hh:mm:ss a')}.zip`
    zip.file('error_info.txt', errorDataJSON);

    zip.generateAsync({ type: 'blob', compression: "DEFLATE" })
      .then((blob) => {

        downLoadErrorLogs(blob, fileName);
      })
      .catch((error) => {
        console.error('Error generating ZIP:', error);
      });

  }

  const downLoadErrorLogs = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    a.click();

    window.URL.revokeObjectURL(url);
  }


const checkIsDecimalOnly = (inputValue) =>{
  return !String(inputValue).toLowerCase().includes("e") && !isNaN(inputValue)
}
const checkIsENotationOnly = (inputValue) =>{
  return String(inputValue).toLowerCase().includes("e") && !isNaN(inputValue)
}

//compute significant figure for Scifi Notation
const countSignificantFiguresForScifi = (numStr) => {
  // Trim whitespace and convert to string
  let num = numStr.toString().trim();

  // Handle scientific notation (x10^ format)
  if (num.toLowerCase().includes("x10^")) {
    let parts = num.split("x10^");
    let base = parts[0].trim();
    return countSignificantFiguresForScifi(base); // Call the function recursively on the base
  }

  // Preserve leading zeros after decimal (e.g., "0.000250" → should count as 3)
  let nonZeroMatch = num.match(/^-?0*(\d+(\.\d*)?|\.\d+)/); 
  if (!nonZeroMatch) return 1; // Edge case: if input is only zeros, return 1
  num = nonZeroMatch[1]; // Extract cleaned number

  // If there’s a decimal, count all digits (including trailing zeros)
  if (num.includes(".")) {
    return num.replace(".", "").length;
  }

  // If no decimal, remove trailing zeros (1000 → "1" (1 sig fig))
  return num.replace(/0+$/, "").length;
};

//compute significant figure for Decimal and Enotation
const  countSignificantFigures = (num) =>  {
  // Handle negative numbers 
  if (num < 0) num = -num;

  // Handle zero explicitly 
  if (num === 0) return 1;

  let numStr = num.toString();

  // Handle scientific notation (e or r notation)
  if (numStr.toLowerCase().includes('e') || numStr.toLowerCase().includes('r')) {
      let [base, exponent] = numStr.toLowerCase().split(/[er]/);
      exponent = parseInt(exponent);

      // Count sig figs in the base part
      let baseSigFigs = base.replace('.', '').replace(/^0+/, '').length;

      return baseSigFigs;
  }

  // Trim any whitespace (just in case)
  numStr = numStr.trim();

  let digits = [];
  let decimalPointIndex = numStr.indexOf('.');
  let i = 0;

  // Skip leading zeros
  while (i < numStr.length && (numStr[i] === '0' || numStr[i] === '.')) {
      if (numStr[i] === '.') decimalPointIndex = i;
      i++;
  }

  // Collect digits starting from the first non-zero digit
  for (; i < numStr.length; i++) {
      let char = numStr[i];
      if (char === '.') {
          decimalPointIndex = i;
          continue;
      }
      digits.push(char);
  }

  // If there's no decimal point, remove trailing zeros
  if (decimalPointIndex === -1) {
      while (digits.length > 0 && digits[digits.length - 1] === '0') {
          digits.pop();
      }
  }

  return digits.length;
}
export { colorsArray, colorsArrayDisPlayOrder, gridUnitSizes, AngleDisplayOptions, getColorsArrayDisPlayOrder,evaluateOptions,QueryOptions,downloadErrorInfo,
  checkIsDecimalOnly,checkIsENotationOnly,countSignificantFiguresForScifi,countSignificantFigures
};

